export default __webpack_public_path__ + "static/media/introBannerBg3.ea0922ca.png";